import React, { useCallback, useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import '@/Adminassets/Style.css';
import '@/Adminassets/Style.css';
import {
    Button,
    Modal,
    Fade,
    TextField,
    Card,
    List,
    ListItem,
    CardContent,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    MenuItem,
    Pagination,
    Select,
    FormControl,
    InputLabel,
    Checkbox,
    ListItemText,
    Tabs,
    Tab,
    Box
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import '@/Adminassets/listVideo.css';
import Form from 'react-bootstrap/Form';
import Autocomplete from '@mui/material/Autocomplete';
import Spinner from '@/component/Spinner';
import { FormCheck } from 'react-bootstrap';
import Button1 from 'react-bootstrap/Button';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '@/data/atoms/utilsAtoms';
import CalendarInput from '@/component/CalendarInput';
import { Helmet } from 'react-helmet-async';
import { useFetchInstructors } from '@/data/swrs/instructor';
import Toast from '@/utils/toastManager';
import axiosConfig from '@/data/utils/axiosConfigInstance';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from 'dayjs';
import { ProductsDropdown } from '@/AdminComponent/ProductsDropdown';
import { newYorkMidnight } from '@/utils/helper';
import ChaptersModal from '@/AdminComponent/ChaptersModal';
import { MUX_UPLOAD_STATUS } from '@/constants/muxUploadStatus'
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import ErrorIcon from '@mui/icons-material/Error';
import FileUploadWithManualInput from '@/AdminComponent/FileUploadWithManualInput';

// Helper function to extract playbackId from muxVideoLink
const getPlaybackId = (muxVideoLink) => {
    return muxVideoLink?.split('/')[3]?.split('.')[0];
};


const AllVideos = () => {
    axios.defaults.withCredentials = true;
    const userData = useAtomValue(userInfoAtom);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 20;
    const [totvideos, setTotVideos] = useState('');
    const [activeTab, setActiveTab] = useState(0);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedVideoType, setSelectedVideoType] = useState('');

    const [sortby, setSortby] = useState('latest');

    const handleFilterChange = (event) => {
        setSortby(event.target.value);
        setCurrentPage(1);
    };

    const redirect = useNavigate();
    const [query, setQuery] = useState('');
    const [videoTypes, setVideoTypes] = useState([]);
    const [backendTags, setBackendTags] = useState([]);
    const [videos, setVideos] = useState([]);
    const [editingUser, setEditingUser] = useState(null);
    const [open, setOpen] = useState(false);
    const [productQuery, setProductQuery] = useState('');
    const [backendProducts, setBackendProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [presentInstrutors, setPresentInstructors] = useState([]);
    const [isAddingNewInstructor, setIsAddingNewInstructor] = useState(false);
    const [newInstructor, setNewInstructor] = useState('');
    const [keywordQuery, setKeywordQuery] = useState('');
    const { instructors, isError } = useFetchInstructors(userData?.token);
    const [selectedTime, setSelectedTime] = useState();
    const [chaptersModalOpen, setChaptersModalOpen] = useState(false);
    const [selectedVideoForChapters, setSelectedVideoForChapters] = useState(null);
    const [isSyncingAlgolia, setIsSyncingAlgolia] = useState(false);

    const handleSyncAlgolia = async () => {
        try {
            setIsSyncingAlgolia(true);
            const response = await axiosConfig.post(`${import.meta.env.VITE_APP_API_URL}/admin/algolia/sync-all`);
            if (response.status === 200) {
                Toast.success(response.data?.message || 'Synced videos to Algolia successfully!');
            } else {
                Toast.error('Failed to sync videos to Algolia');
            }
        } catch (err) {
            console.error('Error syncing videos to Algolia:', err);
            Toast.error(err.response?.data?.error || err.message || 'Failed to sync videos to Algolia');
        } finally {
            setIsSyncingAlgolia(false);
        }
    };


    useEffect(() => {
        setPresentInstructors(instructors);
    }, [instructors]);

    const startPickingFrom = new Date();
    startPickingFrom.setDate(startPickingFrom.getDate() + 1);
    startPickingFrom.setHours(0);
    startPickingFrom.setMinutes(1);
    const excludedDates = new Date();
    excludedDates.setFullYear(excludedDates.getFullYear() - 30);

    dayjs.extend(utc);
    dayjs.extend(timezone);

    const [editedVideoData, setEditedVideoData] = useState({
        _id: '',
        title: '',
        description: '',
        tags: [],
        products: [],
        CategoryId: '',
        videoId: '',
        videoLevel: [],
        videolink: '',
        thumnailLink: '',
        duration: 0,
        releaseDateTime: '',
        releaseDate: '',
        isFeatured: false,
        instructor: '',
        keywords: [],
        shortDescription: '',
        trailerLink: '',
        trailerThumnailLink: '',
    });

    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setEditingUser(null);
        setIsAddingNewInstructor(false);
        setEditedVideoData({
            _id: '',
            title: '',
            description: '',
            tags: [],
            products: [],
            CategoryId: '',
            videoLevel: [],
            videoId: '',
            videolink: '',
            thumnailLink: '',
            duration: 0,
            releaseDateTime: '',
            releaseDate: '',
            instructor: '',
            keywords: [],
            shortDescription: '',
            trailerLink: '',
            trailerThumnailLink: ''
            // isFeatured: false,
        });
    };

    const handleEditClick = (video) => {
        
        setEditingUser(video);

        setEditedVideoData({
            _id: video._id,
            title: video.title,
            description: video.description,
            CategoryId: video.CategoryId,
            videoId: video.videoId,
            videolink: video.muxVideoLink,
            videoLevel: video.videoLevel,
            thumnailLink: video.thumnailLink,
            duration: video.duration,
            releaseDateTime: video?.releaseDateTime,
            releaseDate: video?.releaseDate,
            tags: video.tagsData || video.tagsDetails,
            products: Array.isArray(video?.productsData)
                ? video.productsData : [],
            isFeatured: video.isFeatured,
            instructor: video.instructor,
            keywords: video.keywords || [],
            shortDescription: video.shortDescription || '',
            trailerLink: video.muxTrailerLink,
            trailerThumnailLink: video.trailerThumnailLink,
            type: video?.type || '',
        });

        setKeywordQuery(' ');
        handleOpen();
    };

    const getCurrentDate = () => {
        var timestamp = Date.parse(editedVideoData?.releaseDate);

        if (isNaN(timestamp) === false) {
            return new Date(timestamp);
        } else {
            return new Date();
        }
    };

    const onReleaseDateChange = (date) => {
        const dateOnly = date ? dayjs(date).format('YYYY-MM-DD') : '';

        setEditedVideoData(prev => ({
            ...prev,
            releaseDate: dateOnly,
        }));
    };

    const updateVideo =
        async (videoId, editedVideoDataParam) => {
            try {
                let data = { ...(editedVideoDataParam || editedVideoData) };
                const response = await axiosConfig.put(
                    `${import.meta.env.VITE_APP_API_URL}/video/update/${videoId}`,
                    data
                );

                if (response.status === 200) {
                    Toast.success('Video updated', {
                        position: 'top-center',
                        duration: 3000
                    });
                    fetchData()
                } else if (response.status === 201) {
                    Toast.error('Please Login Again', {
                        position: 'top-center',
                        duration: 3000
                    });
                }
            } catch (error) {
                Toast.error('Something went wrong');
                console.error('Error updating video:', error);
            }
        }



    // Function to handle page change in pagination
    const handlePageChange = (event, newPage) => {
        setCurrentPage(newPage);
    };

    const handleCancelEdit = () => {
        // Reset the editing state
        setEditingUser(null);
        setIsAddingNewInstructor(false);
        setEditedVideoData({
            title: '',
            description: '',
            tags: [],
            products: [],
            videoLevel: [],
            CategoryId: '',
            videoId: '',
            videolink: '',
            thumnailLink: '',
            duration: 0,
            releaseDateTime: '',
            releaseDate: '',
            isFeatured: false,
            keywords: [],
            shortDescription: ''
        });
        handleClose();
    };


    const handleDeleteVideo = videoId => {
        // Make a DELETE request to the API to delete the video
        setDeleteConfirmationOpen(false); // Close the confirmation dialog
        axiosConfig
            .delete(`${import.meta.env.VITE_APP_API_URL}/video/delete/${videoId}`)
            .then(response => {
                if (response.status === 200) {
                    Toast.success('Video deleted');
                    fetchData();
                } else if (response.status === 201) {
                    Toast.error('Please Login Again');
                    redirect('/login');
                }
            })
            .catch(error => {
                Toast.error('Something went wrong', {
                    position: 'top-center',
                    duration: 3000
                });
                console.error('Error deleting video:', error);
            });
    };

    useEffect(() => {
        // Fetch video categories on component mount
        const fetchVideoCategories = async () => {
            try {
                const response = await axios.get(`${import.meta.env.VITE_APP_API_URL}/category`);
                setVideoTypes(response.data);
            } catch (error) {
                console.error('Error fetching video categories:', error);
            }
        };

        fetchVideoCategories();
    }, []);

    useEffect(() => {
        // Fetch tags based on user input
        const performSearch = async () => {
            try {
                const response = await axios.get(`${import.meta.env.VITE_APP_API_URL}/search/tags?query=${query}`);
                const newBackendTags = [];
                response.data?.map(tag => {
                    let flag = true;
                    editedVideoData?.tags?.map(tag1 => {
                        if (tag1.name === tag.name) {
                            flag = false;
                        }
                    });
                    if (flag) {
                        newBackendTags.push(tag);
                    }
                });
                setBackendTags(newBackendTags);
            } catch (error) {
                console.error('Error fetching tags:', error);
            }
        };

        if (query.trim()) {
            performSearch();
        } else {
            setBackendTags([]);
        }
    }, [query]);

    const tagsRef = useRef(null);

    const handleTagAdd = newTag => {
        if (newTag?.trim().length > 0 && !editedVideoData.tags.includes(t => t.name !== newTag)) {
            setEditedVideoData(prevData => ({
                ...prevData,
                tags: [newTag, ...prevData.tags]
            }));
        }
    };

    // Modify the handleTagRemove function to remove the tag from the state and database
    const handleTagRemove = tag => {
        if (tag && tag.name) {
            const updatedTags = editedVideoData.tags.filter(t => t.name !== tag.name);
            setEditedVideoData(prevData => ({
                ...prevData,
                tags: updatedTags
            }));

            // Check if the tag has an _id property
            if (tag._id) {
                // Remove the tag from the database using the correct tag _id
            } else {
                console.error('Tag does not have an _id property:', tag);
            }
        } else {
            console.error('Invalid tag object:', tag);
        }
    };

    const handleKeywordAdd = keyword => {

        if (keyword && editedVideoData && !editedVideoData.keywords.some(kw => kw.name === keyword)) {
            setEditedVideoData(prevData => ({
                ...prevData,
                keywords: [...prevData.keywords, { name: keyword }]
            }));
            setKeywordQuery('');
        } else {
            Toast.error('There is a problem', {
                position: 'top-center',
                duration: 3000
            });
        }
    };

    const handleKeywordRemove = keyword => {
        setEditedVideoData(prevFormData => ({
            ...prevFormData,
            keywords: prevFormData.keywords.filter(k => k !== keyword)
        }));
    };

    useEffect(() => {
        const performSearch = async querySpecial => {
            // console.log(querySpecial);
            try {
                const updatedProducts = editedVideoData.products;
                // console.log(updatedProducts);
                let prodId = [];
                if (updatedProducts && updatedProducts.length > 0) {
                    updatedProducts.map((type, index) => prodId.push(type._id));
                }
                const response = await axios.get(
                    `${import.meta.env.VITE_APP_API_URL}/search/products?query=${querySpecial}&prodId=${prodId}`
                );
                setBackendProducts(response.data);
            } catch (error) {
                console.error(error);
            }
        };

        if (productQuery.trim()) {
            const querySpecial = productQuery.trim();
            // console.log(`queryData${querySpecial}`);
            performSearch(querySpecial);
        } else {
            setBackendProducts([]);
        }
    }, [productQuery]);

    // Auto-refresh to update processing status (background only)
    useEffect(() => {
        const hasProcessingVideos = videos.some(v => v.muxStatus === MUX_UPLOAD_STATUS.PREPARING && Boolean(v.muxUploadId));
        
        if (hasProcessingVideos && !open) {
            const interval = setInterval(async () => {
                const startIndex = (currentPage - 1) * itemsPerPage;
                    const endIndex = startIndex + itemsPerPage;
                    const response = await axios.post(`${import.meta.env.VITE_APP_API_URL}/video/fetch`, {
                        startIndex,
                        endIndex,
                        searchTerm,
                        sortby
                    });
                    
                    setVideos(prevVideos => 
                        prevVideos.map(video => {
                            const updated = response.data.result.find(v => v._id === video._id);
                            return updated ? { ...video, muxStatus: updated.muxStatus, duration: updated.duration } : video;
                        })
                    );
            }, 30000);
            return () => clearInterval(interval);
        }
    }, [videos, open, currentPage, searchTerm, sortby]);

    const handleProductAdd = useCallback(
        async newProduct => {
            if (
                newProduct &&
                newProduct._id &&
                (!editedVideoData.products || !editedVideoData.products.some(p => p._id === newProduct._id))
            ) {


                const dataOfInterest = {
                    _id: newProduct._id,
                    title: newProduct.title
                }

                // Ensure prevData.products is an array or initialize it as an array
                const updatedProducts = Array.isArray(editedVideoData.products)
                    ? [dataOfInterest, ...editedVideoData.products]
                    : [dataOfInterest];

                const newData = {
                    ...editedVideoData,
                    products: [...updatedProducts]
                };
                setEditedVideoData({
                    ...newData
                });
                setProductQuery('');
                return { ...newData };
            }

            setProductQuery('');

        },

        [editedVideoData]
    );

    const productRemoved = useRef(false);

    const handleSaveUser = useCallback(async () => {
        if (editingUser) {
            updateVideo(editingUser.v_id, editedVideoData, selectedTime);
        }


        setEditingUser(null);
        setEditedVideoData(prevData => ({
            ...prevData,
            tags: [],
            keywords: []
        }));
        productRemoved.current = false;
        handleClose();
    }, [editingUser, editedVideoData, productQuery, productRemoved]);

    const showLoader = () => {
        setIsLoading(true);
    };

    const hideLoader = () => {
        setIsLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, [currentPage, sortby, activeTab, selectedCategory, selectedVideoType]);

    const handleSearchVideo = async event => {
        event.preventDefault();
        if (searchTerm === '' || searchTerm.length > 2) {
            setCurrentPage(1);
            fetchData();
        }
    };

    const fetchData = async () => {
        try {
            showLoader();
            const startIndex = (currentPage - 1) * itemsPerPage;
            const endIndex = startIndex + itemsPerPage;
            axios
                .post(`${import.meta.env.VITE_APP_API_URL}/video/fetch`, {
                    startIndex,
                    endIndex,
                    searchTerm,
                    sortby,
                    futureOnly: activeTab === 1,
                    categoryId: selectedCategory,
                    videoType: selectedVideoType
                })
                .then(response => {
                    setTimeout(() => {
                        hideLoader();
                        
                        setVideos(response.data.result);
                        setTotVideos(Math.ceil(response.data.totalRecords / itemsPerPage));
                    }, 500);
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        } catch (error) {
            console.error('Error fetching data: ', error);
        }
    };

    const handleVideoLevelChange = event => {
        setEditedVideoData(prevData => ({
            ...prevData,
            videoLevel: event.target.value
        }));
    };

    return (
        <div>
            <Helmet>
                <title>All Videos | The Godfrey Method - On Demand</title>
                <meta name="description" content="All Videos of The Godfrey Method - On Demand" />
            </Helmet>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                <h1 style={{ margin: 0 }}>Video List</h1>
                <Button1
                    variant="outline-primary"
                    onClick={handleSyncAlgolia}
                    disabled={isSyncingAlgolia}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        fontWeight: 600,
                        padding: '0.5rem 1rem',
                        borderRadius: '0.5rem'
                    }}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2" />
                    </svg>
                    {isSyncingAlgolia ? 'Syncing with Algolia...' : 'Sync with Algolia'}
                </Button1>
            </div>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <Tabs value={activeTab} onChange={(e, newValue) => { setActiveTab(newValue); setCurrentPage(1); }}>
                    <Tab label="All Videos" />
                    <Tab label="Future Releases" />
                </Tabs>
            </Box>
            <div>{isLoading ? <Spinner /> : ''}</div>
            <div className="col-md-12 search-top-container">
                <div className="col-md-6">
                    <div className="search-box-container">
                        <form onSubmit={handleSearchVideo}>
                            <input
                                type="text"
                                id="search"
                                placeholder="Search"
                                value={searchTerm}
                                className="search-input"
                                onChange={e => setSearchTerm(e.target.value)}
                            />
                            <Button1 type='submit' variant="primary">Search</Button1>
                        </form>
                    </div>
                </div>
                <div className="col-md-6">
                    <div class="sort-container" style={{ display: 'flex', gap: '0.64rem', justifyContent: 'flex-end' }}>
                        <div>
                            <label for="category">Category:</label>
                            <select id="category" class="sort-dropdown" onChange={(e) => { 
                                const value = e.target.value;
                                if (value === 'class') {
                                    setSelectedVideoType('class');
                                    setSelectedCategory('');
                                } else {
                                    setSelectedVideoType('');
                                    setSelectedCategory(value);
                                }
                                setCurrentPage(1); 
                            }} value={selectedVideoType === 'class' ? 'class' : selectedCategory}>
                                <option value="">All Categories</option>
                                <option value="class">Class</option>
                                {videoTypes.map((type) => (
                                    <option key={type._id} value={type._id}>{type.name}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label for="sort">Sort by:</label>
                            <select id="sort" class="sort-dropdown" onChange={handleFilterChange} value={sortby}>
                                <option value={'latest'}>Latest First</option>
                                <option value={'oldest'}>Oldest First</option>
                                <option value={'title_asc'}>Title (A - Z)</option>
                                <option value={'title_desc'}>Title (Z - A)</option>
                                <option value={'long_duration'}>Long duration</option>
                                <option value={'short_duration'}>Short duration</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            {!isLoading && (
                <>
                    {videos?.length === 0 && activeTab === 1 ? (
                        <div style={{ textAlign: 'center', padding: '2rem', fontSize: '1.125rem', color: '#666' }}>
                            No videos scheduled for future release
                        </div>
                    ) : videos?.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '2rem', fontSize: '1.125rem', color: '#666' }}>
                            No videos found
                        </div>
                    ) : (
                        <List>
                    {videos?.map(video => {
                        const hasUploadId = Boolean(video.muxUploadId);
                        return (
                            <ListItem key={video._id}>
                            <Card style={{ width: '100%' }}>
                                <div className="video-item list-Video">
                                    <div className="video-thumbnail">
                                        <img
                                            className="w-10 h-10"
                                            style={{ width: '100%', height: '100%' }}
                                            src={video.thumnailLink}
                                            alt=""
                                        />
                                    </div>
                                    <div className="video-details">
                                        <h2>
                                            <strong>{video?.title}</strong>
                                        </h2>
                                        {/* Mux Processing Status Badge */}
                                        {video.muxStatus && video.muxStatus !== MUX_UPLOAD_STATUS.READY && hasUploadId && (
                                        <div style={{
                                            display: 'inline-block',
                                            padding: '0.25rem 0.75rem',
                                            borderRadius: '0.25rem',
                                            fontSize: '0.75rem',
                                            fontWeight: 'bold',
                                            marginBottom: '0.5rem',
                                            backgroundColor: video.muxStatus === MUX_UPLOAD_STATUS.PREPARING ? '#fff3e0' : '#ffebee',
                                            color: video.muxStatus === MUX_UPLOAD_STATUS.PREPARING ? '#f57c00' : '#c62828',
                                        }}>
                                            {video.muxStatus === MUX_UPLOAD_STATUS.PREPARING ? (
                                                <><HourglassTopIcon style={{ fontSize: '0.75rem', marginRight: '0.25rem' }} /> Processing...</>
                                            ) : (
                                                <><ErrorIcon style={{ fontSize: '0.75rem', marginRight: '0.25rem' }} /> Processing Failed</>
                                            )}
                                        </div>
                                        )}
                                        <div dangerouslySetInnerHTML={{ __html: video.description }} />
                                        <span className="tag-video">
                                            <strong>Tags:</strong>
                                            <ul
                                                style={{
                                                    display: 'flex',
                                                    listStyleType: 'none',
                                                    padding: '0px'
                                                }}
                                            >
                                                {(video.tagsData || video?.tagsDetails).map((tag, index) => (
                                                    <li
                                                        key={index}
                                                        style={{
                                                            backgroundColor: tag.color,
                                                            margin: '0.313rem 0.563rem 0.438rem 0.375rem',
                                                            border: '0px solid black',
                                                            borderRadius: '0.188rem',
                                                            color: '#fff',
                                                            padding: '0.125rem 0.625rem',
                                                            textTransform: 'capitalize'
                                                        }}
                                                    >
                                                        {tag?.name || tag}
                                                    </li>
                                                ))}
                                            </ul>
                                        </span>
                                        <div className="catName">
                                            <strong>Category:</strong>
                                            <span>{video.CategoryDetails[0]?.name}</span>
                                        </div>
                                        <div className="video-actions">
                                            <button
                                                style={{
                                                    margin: '0.188rem',
                                                    padding: '0.625rem 1.25rem',
                                                    fontSize: '0.938rem',
                                                    textTransform: 'uppercase',
                                                    opacity: (video.muxStatus === MUX_UPLOAD_STATUS.PREPARING && hasUploadId) ? 0.2 : 1,
                                                    cursor: (video.muxStatus === MUX_UPLOAD_STATUS.PREPARING && hasUploadId) ? 'not-allowed' : 'pointer'
                                                }}
                                                className="btn btn-secondary"
                                                onClick={() => handleEditClick(video)}
                                                disabled={video.muxStatus === MUX_UPLOAD_STATUS.PREPARING && hasUploadId}
                                                >
                                                Edit
                                            </button>
                                            <button
                                                style={{
                                                    margin: '0.19rem',
                                                    padding: '0.63rem 1.25rem',
                                                    fontSize: '0.94rem',
                                                    textTransform: 'uppercase',
                                                    opacity: (video.muxStatus === MUX_UPLOAD_STATUS.PREPARING && hasUploadId) ? 0.2 : 1,
                                                    cursor: (video.muxStatus === MUX_UPLOAD_STATUS.PREPARING && hasUploadId) ? 'not-allowed' : 'pointer'
                                                }}
                                                className="btn btn-info"
                                                onClick={() => {
                                                    setSelectedVideoForChapters(video);
                                                    setChaptersModalOpen(true);
                                                }}
                                                disabled={video.muxStatus === MUX_UPLOAD_STATUS.PREPARING && hasUploadId}
                                                >
                                                Chapters
                                            </button>
                                            <button
                                                style={{
                                                    margin: '1vh',
                                                    padding: '10px 20px',
                                                    fontSize: '15px',
                                                    textTransform: 'uppercase',
                                                    opacity: (video.muxStatus === MUX_UPLOAD_STATUS.PREPARING && hasUploadId) ? 0.2 : 1,
                                                    cursor: (video.muxStatus === MUX_UPLOAD_STATUS.PREPARING && hasUploadId) ? 'not-allowed' : 'pointer'
                                                }}
                                                className="btn btn-dark"
                                                onClick={() => {
                                                    setEditingUser(video);
                                                    setDeleteConfirmationOpen(true);
                                                }}
                                                disabled={video.muxStatus === MUX_UPLOAD_STATUS.PREPARING && hasUploadId}
                                                >
                                                Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </ListItem>
                        );
                    })}
                        </List>
                    )}
                </>
            )}
            {/* Material-UI Pagination */}
            {!isLoading && (
                <div
                    style={{
                        margin: '20px 0',
                        display: 'flex',
                        justifyContent: 'center'
                    }}
                >
                    <Pagination
                        count={totvideos}
                        page={currentPage}
                        onChange={handlePageChange}
                        variant="outlined"
                        shape="rounded"
                    />
                </div>
            )}

            {/* Material-UI Modal for Edit */}
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Fade in={open}>
                    <div>
                        <Card
                            style={{
                                background: '#fff',
                                maxWidth: 900,
                                width: '100%',
                                padding: 16,
                                maxHeight: '90vh',
                                overflow: 'auto'
                            }}
                        >
                            <CardContent>
                                <h2>Edit Video</h2>
                                <TextField
                                    label="Title"
                                    fullWidth
                                    margin="normal"
                                    value={editedVideoData.title}
                                    onChange={e =>
                                        setEditedVideoData({
                                            ...editedVideoData,
                                            title: e.target.value
                                        })
                                    }
                                />
                                <TextField
                                    label="Video Link"
                                    fullWidth
                                    margin="normal"
                                    value={editedVideoData.videolink}
                                    onChange={e =>
                                        setEditedVideoData({
                                            ...editedVideoData,
                                            videolink: e.target.value
                                        })
                                    }
                                    disabled
                                />
                                {editedVideoData.type === 'class' && (
                                    <>
                                        <TextField
                                            label="Trailer Link"
                                            fullWidth
                                            margin="normal"
                                            value={editedVideoData.trailerLink}
                                            onChange={e =>
                                                setEditedVideoData({
                                                    ...editedVideoData,
                                                    trailerLink: e.target.value
                                                })
                                            }
                                            disabled
                                        />
                                        <Box sx={{ mt: 2, mb: 1 }}>
                                            <FileUploadWithManualInput
                                                label="Trailer Thumbnail Link"
                                                accept="image/*"
                                                currentUrl={editedVideoData.trailerThumnailLink}
                                                onChange={url =>
                                                    setEditedVideoData({
                                                        ...editedVideoData,
                                                        trailerThumnailLink: url
                                                    })
                                                }
                                            />
                                        </Box>

                                    </>
                                )}

                                <Box sx={{ mt: 2, mb: 1 }}>
                                    <FileUploadWithManualInput
                                        label="Thumbnail Link"
                                        accept="image/*"
                                        currentUrl={editedVideoData.thumnailLink}
                                        onChange={url =>
                                            setEditedVideoData({
                                                ...editedVideoData,
                                                thumnailLink: url
                                            })
                                        }
                                    />
                                </Box>

                                <TextField
                                    label="Duration"
                                    fullWidth
                                    margin="normal"
                                    value={editedVideoData.duration}
                                    onChange={e =>
                                        setEditedVideoData({
                                            ...editedVideoData,
                                            duration: e.target.value
                                        })
                                    }
                                    disabled
                                />
                                <TextField
                                    label="Description"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    margin="normal"
                                    value={editedVideoData.description}
                                    onChange={e =>
                                        setEditedVideoData({
                                            ...editedVideoData,
                                            description: e.target.value
                                        })
                                    }
                                />
                                <TextField
                                    label="Short Description"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    margin="normal"
                                    value={editedVideoData.shortDescription}
                                    onChange={e =>
                                        setEditedVideoData({
                                            ...editedVideoData,
                                            shortDescription: e.target.value
                                        })
                                    }
                                />

                                <FormControl fullWidth margin="normal">
                                    <InputLabel>Instructor</InputLabel>
                                    <Select
                                        label="Instructor"
                                        value={isAddingNewInstructor ? newInstructor : editedVideoData.instructor || ''}
                                        onChange={e => {
                                            if (e.target.value === 'addNew') {
                                                setIsAddingNewInstructor(true);
                                                setNewInstructor('');
                                                setEditedVideoData({
                                                    ...editedVideoData,
                                                    instructor: ''
                                                });
                                            } else {
                                                setIsAddingNewInstructor(false);
                                                setEditedVideoData({
                                                    ...editedVideoData,
                                                    instructor: e.target.value
                                                });
                                            }
                                        }}
                                    >
                                        {presentInstrutors?.map((instructor, index) => (
                                            <MenuItem key={index} value={instructor.name}>
                                                {instructor.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <TextField
                                    select
                                    label="Select Category"
                                    fullWidth
                                    margin="normal"
                                    value={editedVideoData.CategoryId}
                                    onChange={e =>
                                        setEditedVideoData({
                                            ...editedVideoData,
                                            CategoryId: e.target.value
                                        })
                                    }
                                >
                                    {videoTypes.map((type, index) => (
                                        <MenuItem key={index} value={type._id}>
                                            {type.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <FormControl className="mt-1" fullWidth>
                                    <InputLabel id="video-level">Choose the Level</InputLabel>
                                    <Select
                                        labelId="video-level"
                                        id="videoLevel"
                                        name="videoLevel"
                                        multiple
                                        value={editedVideoData?.videoLevel}
                                        onChange={handleVideoLevelChange}
                                        label="Choose the Level"
                                        renderValue={selected => {
                                            if (Array.isArray(selected)) {
                                                return selected.join(', ');
                                            }

                                            // Handle non-array cases
                                            return selected || ''; // Display single value or empty string
                                        }}
                                    >
                                        <MenuItem value="" disabled>
                                            <em>Select The Level of the Video</em>
                                        </MenuItem>
                                        <MenuItem value="Beginner">
                                            <Checkbox checked={editedVideoData.videoLevel.includes('Beginner')} />
                                            <ListItemText primary="Beginner" />
                                        </MenuItem>
                                        <MenuItem value="Intermediate">
                                            <Checkbox checked={editedVideoData.videoLevel.includes('Intermediate')} />
                                            <ListItemText primary="Intermediate" />
                                        </MenuItem>
                                        <MenuItem value="Advanced">
                                            <Checkbox checked={editedVideoData.videoLevel.includes('Advanced')} />
                                            <ListItemText primary="Advanced" />
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                                <div style={{ display: 'flex', gap: '3rem', width: '100%' }}>
                                    <FormControl
                                        controlId="description"
                                        style={{
                                            width: '100%',
                                            marginTop: '16px'
                                        }}
                                    >
                                        <Form.Label>Release Date</Form.Label>
                                        <div
                                            style={{
                                                position: 'relative',
                                                width: '100%',
                                                height: '100%',
                                                zIndex: 1000
                                            }}
                                        >
                                            <DatePicker
                                                onChange={onReleaseDateChange}
                                                minDate={newYorkMidnight()}
                                                selected={getCurrentDate()}
                                                dateFormat="MMMM d, yyyy"
                                                customInput={<CalendarInput />}
                                            />
                                        </div>
                                    </FormControl>

                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Autocomplete
                                        ref={tagsRef}
                                        freeSolo
                                        options={backendTags.map(tag => tag.name)}
                                        inputValue={query}
                                        onInputChange={(event, newInputValue) => setQuery(newInputValue)}
                                        onChange={(e, option) => {
                                            handleTagAdd(option);
                                            setQuery('');
                                        }}
                                        renderInput={params => <TextField {...params} label="Add Tag" fullWidth value={query} />}
                                    />
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            marginRight: '10px'
                                        }}
                                    >
                                        {editedVideoData.tags
                                            ?.filter(tag => tag) // Filter out null or undefined tags
                                            .map((tag, index) => (
                                                // debugger
                                                <div key={index} className="tag">
                                                    {tag?.name || tag /* Use optional chaining to handle undefined tags */}
                                                    <span onClick={() => handleTagRemove(tag)}>x</span>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                                <ProductsDropdown
                                    value={editedVideoData.products || []}
                                    onChange={(newProducts) => setEditedVideoData({ ...editedVideoData, products: newProducts })}
                                />
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        marginTop: '1rem'
                                    }}
                                >
                                    <Autocomplete
                                        freeSolo
                                        options={[]} // no predefined options
                                        inputValue={keywordQuery}
                                        onInputChange={(event, newInputValue) => setKeywordQuery(newInputValue)}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label="Add Keyword"
                                                fullWidth
                                                onKeyDown={e => {
                                                    if (e.key === 'Enter' || e.key === 'Tab') {
                                                        handleKeywordAdd(e.target.value);
                                                        setKeywordQuery('');
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            marginRight: '10px'
                                        }}
                                    >
                                        {editedVideoData.keywords?.map((keyword, index) => (
                                            <div key={index} className="tag">
                                                {keyword.name}
                                                <span onClick={() => handleKeywordRemove(keyword)}>x</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <FormCheck
                                    className="mt-1"
                                    type="checkbox"
                                    id="isFeatured"
                                    label="Add to Featured Playlist"
                                    checked={editedVideoData.isFeatured}
                                    onChange={() =>
                                        setEditedVideoData(prevData => ({
                                            ...prevData,
                                            isFeatured: !prevData.isFeatured
                                        }))
                                    }
                                />
                                <div
                                    style={{
                                        marginTop: 16,
                                        display: 'flex',
                                        justifyContent: 'space-between'
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            handleSaveUser();
                                        }}
                                    >
                                        Save
                                    </Button>
                                    <Button variant="contained" color="secondary" onClick={handleCancelEdit}>
                                        Cancel
                                    </Button>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                </Fade>
            </Modal>

            {/* Material-UI Dialog for Delete Confirmation */}
            <Dialog open={deleteConfirmationOpen} onClose={() => setDeleteConfirmationOpen(false)}>
                <DialogTitle>Delete Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>Are you sure you want to delete this video?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDeleteConfirmationOpen(false)} color="primary">
                        No
                    </Button>
                    <Button onClick={() => handleDeleteVideo(editingUser.v_id)} color="primary">
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Chapters Management Modal */}
            <ChaptersModal
                open={chaptersModalOpen}
                onClose={() => {
                    setChaptersModalOpen(false);
                    setSelectedVideoForChapters(null);
                }}
                videoId={selectedVideoForChapters?._id}
                playbackId={getPlaybackId(selectedVideoForChapters?.muxVideoLink)}
                videoDuration={selectedVideoForChapters?.duration}
            />
        </div>
    );
};

export default AllVideos;
